/*
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
require('daemonite-material');
*/
import 'expose-loader?Popper!popper.js';
import 'script-loader!bootstrap';
import 'script-loader!daemonite-material';


// Config
import 'script-loader!js-cookie';
import '../ext/config.js';

// Styles
import './app.scss';

// General
import './general.js';


// Form Control
import './form.js';

// Floatbar, menu
import './floatbar.js';

// Modal
import './popup.js';

// Member
import './member.js';

// Cart
import './cart.js';

// Product
import './product.js';

// Home new
import './themNew.js';

// Landing page
import './ladipage.js';


// WEBPACK FOOTER //
// ./src/app.js